<template>
    <div :class="'stream-item-header' + positionClasses">{{ createdAt | humanDayTime }}<span v-if="createdBy"> - {{ createdBy.name }}</span></div>
</template>

<style lang="scss">
    .stream-item-header {
        padding: 1rem 1.5rem 0rem;
        color: #999;

        &.stream-item-header-bottom {
            padding: .5rem 1.5rem 1.5rem;
        }
    }
</style>

<script>
    import Filters from '../../../filters'

    export default {
        filters: Filters,
        props: {
            createdBy: {
                type: Object
            },
            createdAt: {
                type: [Object, String, Date],
                required: true
            },
            position: {
                type: String,
                default: 'top'
            }
        },
        computed: {
            positionClasses() {
                return ' stream-item-header-' + this.position
            }
        }
    }
</script>